import React from 'react';
import Sramdhan2025 from '../views/Sramdham2025';

const BlogNewsroomPage = () => {
return <Sramdhan2025/>
};
export default BlogNewsroomPage;